module.exports = __webpack_public_path__ + "static/halloween2.f34626cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/halloween2.jpg
// module id = 350
// module chunks = 35783957827783